export enum GoalStatus {
  Completed = 'Completed',
  NotCompleted = 'Not Completed',
  NotStarted = 'Not Started',
  OffTrack = 'Off Track',
  OnTrack = 'On Track',
  Overwritten = 'Overwritten',
}
